import React, { FC } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JETNotificationPermission from '@assets/JETNotificationPermission.svg';
import JetButton from '../JetButton';
import { NotificationConsent } from '@src/shared/services/util-storage';
import { useTranslation } from 'react-i18next';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';

interface INotificationPermission {
  onConsent: (consent: NotificationConsent) => void;
}

const NotificationPermission: FC<INotificationPermission> = ({ onConsent }) => {
  const classes = useStyles();
  const { t } = useTranslation();


  return (
    <div className={classes.notificationPermission}>
      <div className={classes.notificationPermissionHeader}>
        <img src={JETNotificationPermission} />
        <JetFontIcon
          className={classes.closeIcon}
          size={14}
          onClick={() => onConsent(NotificationConsent.ON_REFRESH)}
          iconname={JET_FONTICON_ALIASES.CLOSE}
        />
      </div>
      <div className={classes.notificationPermissionBody}>
        <Typography variant="body1" className="body_bold">
          {t('permission.notification_header')}
        </Typography>
        <Typography variant="body1" className="body_small_regular">
          {t('permission.notification_body')}
        </Typography>
      </div>
      <div className={classes.notificationPermissionFooter}>
        <div className={classes.notificationPermissionFooterButton}>
          <Typography
            variant="body1"
            className="body_bold"
            onClick={() => onConsent(NotificationConsent.SHOW_LATER)}
          >
            {t('permission.cta_notification_later')}
          </Typography>
        </div>
        <div className={classes.notificationPermissionFooterButton}>
          <JetButton
            variation="primary"
            size="small"
            onClick={() => onConsent(NotificationConsent.CONSENT_FULL)}
          >
            {t('permission.cta_notification_allow')}
          </JetButton>
        </div>
      </div>
    </div>
  );
};

export default NotificationPermission;
